export default class Controller {

	static get $inject(){
		return [
			'$element'
		];
	}

	constructor($element){
		this.$element = $element;
		this.offset = 1000;
		this.e = this.$element[0];
		this.e.scrollTop = 0;

	}

	// --- LifeCycle hooks ---

	$onInit(){
		this.$element.bind('scroll', ()=>{

			if( this.e.scrollTop + this.e.offsetHeight >= this.e.scrollHeight - this.offset ){
				//scope.$apply(attrs.handle);
				if( !this.busy ){
					// console.log('updating: ', this.e.scrollTop, this.e.offsetHeight, this.e.scrollHeight, this.offset)
					this.onUpdate();
				}else{
					//console.log('busy...')
				}
			}
		});
	}

	$onChanges(changesObj){
		/* $onChanges(changesObj) - Called whenever one-way bindings are updated.
		 * The changesObj is a hash whose keys are the names of the bound properties that have changed,
		 * and the values are an object of the form { currentValue, previousValue, isFirstChange() }.
		 * Use this hook to trigger updates within a component such as
		 * cloning the bound value to prevent accidental mutation of the outer value. */
	}

}


/*export default angular.module('iscroll.module', [])
 .directive('iscroll', [function(){
 return {
 link: function(scope, element, attrs){

 var offset = parseInt(attrs.threshold) || 0;
 var e = element[0];
 e.scrollTop = 0;

 console.log( '-->',e.scrollTop, e.offsetHeight, offset);

 element.bind('scroll', function(){
 console.log( '-->',e.scrollTop + e.offsetHeight >= e.scrollHeight - offset);
 if( e.scrollTop + e.offsetHeight >= e.scrollHeight - offset ){
 scope.$apply(attrs.handle);
 }
 });

 }
 };
 }])
 .name;*/


/** WEBPACK FOOTER **
 ** ./src/components/infinite-scroll/controller.js
 **/